// Cebuano translations
export const ceb: Record<string, string> = {
  'menu.dashboard': 'Dashboard',
  'menu.customers': 'Mga Kostumer',
  'menu.products': 'Mga Produkto',
  'menu.users': 'Mga Tiggamit',
  'menu.settings': 'Mga Setting',
  'menu.logout': 'Logout',
  'dashboard.title': 'Dashboard',
  'dashboard.newOrder': 'Bag-ong Order',
  'order.title': 'Bag-ong Order',
  'order.customer': 'Kostumer',
  'order.products': 'Mga Produkto',
  'order.total': 'Kinatibuk-an',
  'users.title': 'Mga Tiggamit',
  'users.name': 'Ngalan',
  'users.email': 'Email',
  'common.yes': 'Oo',
  'common.no': 'Dili',
  'common.cancel': 'Kanselahon',
  'common.save': 'I-save',
  'common.search': 'Pangitaa',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Login',
  'login.welcome': 'Maayong pag-abot, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Email',
  'signup.phone': 'Telepono',
  'menu.reportsAndAccounting': 'Mga Report ug Accounting',
  'menu.systemAndCommunication': 'Sistema ug Komunikasyon',
};